// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Vqe0","productName":"Table_productName__3NC9s"};